import type { IRogue } from '../services/RogueTypes'

// Asserted server-side in server/services/recaptcha.ts - the two must stay in sync
export const NEWSLETTER_SIGNUP_ACTION = 'newsletter_signup'

const SUBSCRIBE_URL = '/svc_ssr/newsletters/subscribe'

export type NewsletterSubscribeRequest = {
  email: string,
  userId?: string | null,
  newsletters: number[],
}

export type NewsletterSubscribeResponse = {
  success: boolean,
}

/*
 * Every newsletter signup goes through here so the endpoint, its captcha action, and the
 * response shape live in one place. The endpoint rejects requests without a valid token,
 * so callers must not fall back to a plain rogue.fetch().
 */
export function subscribeToNewsletters(rogue: IRogue, request: NewsletterSubscribeRequest): Promise<NewsletterSubscribeResponse> {
  return rogue.fetchWithCaptcha<NewsletterSubscribeResponse>(
    SUBSCRIBE_URL,
    'POST',
    request,
    {},
    'json',
    NEWSLETTER_SIGNUP_ACTION
  )
}
